import React, { useEffect, useState } from "react";
import performRequest from "../../api/request";
import LoadingPage from "../../Components/layouts/loading";
import { Toast } from "../../CustomComponent/toast";
import Footer from "../../Components/Footer/footer";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import { useSelector } from "react-redux";
import { LeadInfo } from "../../SchemaInfo/info";
import { useNavigate } from "react-router-dom";
import SimpleButton from "../../Components/layouts/simple_button";
import { FcAddDatabase, FcAreaChart, FcClearFilters } from "react-icons/fc";
import { set } from "date-fns";

function formatSecondsToHMS(seconds) {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  const pad = (n) => n.toString().padStart(2, "0");
  return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
}

const LeadsTrackingSystem = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [allLeadsData, setAllLeadsData] = useState();
  const [leadOwner, setLeadOwner] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [modalData, setModalData] = useState();
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");
  const [revenueData, setRevenueData] = useState();
  const [revenue, setRevenue] = useState();

  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    leadOwner: "",
    name: "",
  });
  const [callTrackingToday, setCallTrackingToday] = useState();
  const role = useSelector((state) => state.login.user.Role);
  const store = useSelector((store) => store.login.user);
  const [pages, setPages] = useState({
    coldLeads: 1,
    followUp1: 1,
    followUp2: 1,
    followUp4: 1,
    followUp1W: 1,
    followUp2W: 1,
    followUp1M: 1,
    pendingFlw: 1,
    todaysFlw: 1,
  });

  const [openFollowup, setOpenFollowup] = useState(null);

  // const [employee, setEmployee] = useState(
  //   store &&
  //     (store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
  //       store.Role === process.env.REACT_APP_ROLE_ADMIN)
  //     ? "all"
  //     : store.Name
  // );

  const toggleFollowup = (id) => {
    setOpenFollowup(openFollowup === id ? null : id);
  };

  useEffect(() => {
    performRequest("GET", "/leads/getSalesEmployeeList/")
      .then((res) => {
        setLeadOwner(res.data);
      })
      .catch((err) => CustomErrorResponse(err));
  }, []);

  // useEffect(() => {
  //   performRequest("GET", getFilteredURL("/leads_v2/get_leads", 1, filters))
  //     .then((res) => {
  //       if (res.status === 200) {
  //         setAllLeadsData(res?.data);
  //       }
  //     })
  //     .catch((err) => CustomErrorResponse(err));
  // }, [refresh]);

  useEffect(() => {
    if (pages) {
      const query = new URLSearchParams({
        ...filters,
        page_coldLeads: pages.coldLeads,
        page_followUp1: pages.followUp1,
        page_followUp2: pages.followUp2,
        page_followUp4: pages.followUp4,
        page_followUp1W: pages.followUp1W,
        page_followUp2W: pages.followUp2W,
        page_followUp1M: pages.followUp1M,
        page_pendingFlw: pages.pendingFlw,
        page_todaysFlw: pages.todaysFlw,
      }).toString();

      setLoading(true);

      performRequest("GET", `/leads_v2/get_leads?${query}`)
        .then((res) => {
          if (res.status === 200) {
            setAllLeadsData(res.data);
            // setRevenueData(res.data?.revenueOwnerWise);
            setLoading(false);
          }
        })
        .catch((err) => CustomErrorResponse(err));
    }
  }, [pages, refresh]);

  // useEffect(() => {
  //   if (
  //     employee &&
  //     (store.Role === process.env.REACT_APP_ROLE_ADMIN ||
  //       store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
  //       store.Role === process.env.REACT_APP_ROLE_SALES_MANAGER ||
  //       store.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
  //       store.Role === process.env.REACT_APP_ROLE_SALLE)
  //   ) {
  //     performRequest("GET", `/incentive/totalRevenueOfMonthByName/${employee}`)
  //       .then((res) => {
  //         if (res.status === 200) {
  //           if (
  //             res.data.totalRevenue &&
  //             typeof +res.data.totalRevenue === "number"
  //           ) {
  //             setRevenue(res.data?.totalRevenue?.toFixed(2));
  //           } else {
  //             setRevenue(res.data?.totalRevenue);
  //           }
  //         }
  //       })
  //       .catch((err) => {
  //         CustomErrorResponse(err);
  //       });
  //   }
  // }, [employee]);

  useEffect(() => {
    performRequest("GET", "/leads_v2/enquiries")
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.enquries);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, [refresh]);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL(`/callTracking/getAllCallTracking`, 1, {
        leadowner:
          role === process.env.REACT_APP_ROLE_ADMIN_S ||
          role === process.env.REACT_APP_ROLE_HR
            ? userEmail
            : store?.Email,
        startdate: new Date().toISOString().split("T")?.[0],
        enddate: "",
      })
    )
      .then((res) => {
        if (res.status === 200) {
          setCallTrackingToday(res.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => CustomErrorResponse(err))
      .finally(() => setLoading(false));
  }, [store, refresh]);

  if (loading) return <LoadingPage />;

  const getName = (lead) => {
    if (lead.fullName) {
      return lead.fullName;
    }
    if (lead.firstName && lead.lastName) {
      return `${lead.firstName} ${lead.lastName}`;
    }
    if (lead.firstName) {
      return lead.firstName;
    }
    if (lead.lastName) {
      return lead.lastName;
    }
    return "N/A";
  };

  const handleCall = (phoneNumber) => {
    if (phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    } else {
      alert("Phone number is not available!");
    }
  };

  const AddAndAssignLead = (values) => {
    const lead = {
      ...LeadInfo,
      first_name: values?.firstName || values?.fullName || "",
      last_name: values?.lastName || "",
      full_name: getName(values),
      interestedIn: values?.interestedIn || [],
      services: "",
      planned_area: "",
      location_type: "",
      company_name: values?.businessName || "",
      lead_genrated_from: "enquiry",
      lead_alloted_to: store?.Name || "",
      reAssignTo: store?.Name || "",
      preferred_contact_method: "",
      contact_number: values?.mobileNumber || values?.whatsappNumber || "",
      lead_status: "",
      email: values?.email || "",
      gst_number: values?.gst_number || "",
      address: values?.address1 || values?.address2 || "",
      notes: values?.summary || values?.notes || "",
      origin: values?.origin,
      enquiry_related_to: values?.enquiryRelated,
      preferred_language: values?.preferredLanguage,
      aiScript: values?.aiScript || [],
      lead_quality: values?.lead_quality || "",
      summary: values?.summary || "",
      call_status: values?.call_status || "",
    };

    navigate("/leads/add-new-lead", { state: lead });
  };

  const assignNewEnquires = () => {
    performRequest("GET", `/leads_v2/assign_new_enquries/`)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "New Enquires added successfully");
          setRefresh(!refresh);
        } else {
          Toast(
            "Error while getting Enquires or Enquires assigned limit exceeded"
          );
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  const statuses = [
    "Pending Followup",
    "Todays Leads",
    "Today's Foll. Last",
    "Today's Foll. Inside",
    "followup in one day",
    "followup in two day",
    "followup in four day",
    "followup in one week",
    "followup in two week",
    "followup in one month",
    // "followup in next year",
    "cold lead",
  ];

  // const getLeadsByStatus = (status) => {
  //   if (status === "Todays Leads") {
  //     return data?.filter(
  //       (lead) => !lead.lead_status || lead.lead_status === ""
  //     );
  //   } else if (status === "Today's Followups") {
  //     return allLeadsData?.todaysFlw;
  //   } else if (status === "followup in one day") {
  //     return allLeadsData?.followUp1;
  //   } else if (status === "followup in two day") {
  //     return allLeadsData?.followUp2;
  //   } else if (status === "followup in four day") {
  //     return allLeadsData?.followUp4;
  //   } else if (status === "followup in one week") {
  //     return allLeadsData?.followUp1W;
  //   } else if (status === "followup in two week") {
  //     return allLeadsData?.followUp2W;
  //   } else if (status === "followup in one month") {
  //     return allLeadsData?.followUp1M;
  //   } else if (status === "Pending Followup") {
  //     return allLeadsData?.pendingFlw;
  //   } else if (status === "cold lead") {
  //     return allLeadsData?.coldLeads;
  //   }
  //   return data?.filter((lead) => lead.lead_status === status);
  // };

  const getLeadsByStatus = (status) => {
    // ✅ NO PAGINATION (keep old logic)
    if (status === "Todays Leads") {
      return data?.filter(
        (lead) => !lead.lead_status || lead.lead_status === ""
      );
    }

    // ✅ PAGINATED DATA (use .data)
    if (status === "Today's Foll. Last") {
      return allLeadsData?.todaysFlw?.data || [];
    }
    if (status === "Today's Foll. Inside") {
      return allLeadsData?.todaysFlwAll?.data || [];
    }
    if (status === "followup in one day") {
      return allLeadsData?.followUp1?.data || [];
    }
    if (status === "followup in two day") {
      return allLeadsData?.followUp2?.data || [];
    }
    if (status === "followup in four day") {
      return allLeadsData?.followUp4?.data || [];
    }
    if (status === "followup in one week") {
      return allLeadsData?.followUp1W?.data || [];
    }
    if (status === "followup in two week") {
      return allLeadsData?.followUp2W?.data || [];
    }
    if (status === "followup in one month") {
      return allLeadsData?.followUp1M?.data || [];
    }
    if (status === "Pending Followup") {
      return allLeadsData?.pendingFlw?.data || [];
    }
    if (status === "cold lead") {
      return allLeadsData?.coldLeads?.data || [];
    }

    return [];
  };

  const statusKeyMap = {
    "Today's Followups": "todaysFlw",
    "followup in one day": "followUp1",
    "followup in two day": "followUp2",
    "followup in four day": "followUp4",
    "followup in one week": "followUp1W",
    "followup in two week": "followUp2W",
    "followup in one month": "followUp1M",
    "Pending Followup": "pendingFlw",
    "cold lead": "coldLeads",
  };

  const handleLoadMore = (statusKey) => {
    setPages((prev) => ({
      ...prev,
      [statusKey]: (prev[statusKey] || 1) + 1,
    }));
  };

  const handlePrev = (statusKey) => {
    setPages((prev) => ({
      ...prev,
      [statusKey]: Math.max((prev[statusKey] || 1) - 1, 1),
    }));
  };

  const handleNotReceived = async (lead) => {
    try {
      const res = await performRequest(
        "PATCH",
        `/leads_v2/not_recived/${lead.id}`
      );

      if (res.status === 200) {
        Toast("success", "Enquiry moved bottom");

        setRefresh(!refresh);
      }
    } catch (err) {
      CustomErrorResponse(err);
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="card shadow-sm p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="col">
              <h2 className="page-title">
                <FcAreaChart className="fs-2  me-1" />
                Leads Tracking System
              </h2>
              {/* <h4 className="text-muted">
                <StepRoutes />
              </h4> */}
            </div>
            <div className="dropdown">
              <button className="btn btn-primary" data-bs-toggle="dropdown">
                <FcClearFilters size={18} />{" "}
                <span className="ms-1">Apply Filters</span>
              </button>
              <button
                className="btn btn-primary ms-2"
                onClick={() => navigate("/leads/add-new-lead")}
              >
                <FcAddDatabase size={18} />
                <span className="ms-1">Add Lead</span>
              </button>

              <div
                className="dropdown-menu dropdown-menu-end p-3"
                style={{ minWidth: "250px" }}
              >
                <DynamicFilterInput
                  label="Start date"
                  value={filters.startdate}
                  onChange={(e) =>
                    setFilters({ ...filters, startdate: e.target.value })
                  }
                  type="date"
                />

                <DynamicFilterInput
                  label="End date"
                  value={filters.enddate}
                  onChange={(e) =>
                    setFilters({ ...filters, enddate: e.target.value })
                  }
                  type="date"
                />

                <DynamicFilterInput
                  label="Name / Mobile"
                  value={filters.name}
                  onChange={(e) =>
                    setFilters({ ...filters, name: e.target.value })
                  }
                  type="text"
                  placeholder="Search name/mobile"
                />

                {(role === process.env.REACT_APP_ROLE_ADMIN_S ||
                  role === process.env.REACT_APP_ROLE_ADMIN ||
                  role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                  role === process.env.REACT_APP_ROLE_HR) && (
                  <DynamicFilterSelect
                    label="Lead Owner"
                    value={filters.leadOwner}
                    onChange={(e) => {
                      let email = "";
                      leadOwner.filter((el) => {
                        if (el.id == e.target.value) {
                          email = el.email;
                        }
                      });
                      setUserEmail(email);
                      setFilters({ ...filters, leadOwner: e.target.value });
                    }}
                  >
                    <option value="">All</option>
                    {leadOwner?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.userName}
                      </option>
                    ))}
                  </DynamicFilterSelect>
                )}

                <div className="d-flex gap-2 mt-2">
                  <button
                    className="btn btn-primary w-100"
                    onClick={() => setRefresh(!refresh)}
                  >
                    Search
                  </button>

                  <button
                    className="btn btn-secondary w-100"
                    onClick={() => {
                      setUserEmail("");
                      setFilters({
                        startdate: "",
                        enddate: "",
                        leadOwner: "",
                        name: "",
                      });
                      setRefresh(!refresh);
                    }}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* STATS */}
          <div className="row g-2">
            {/* {(revenueData && role === process.env.REACT_APP_ROLE_ADMIN_S) ||
            role === process.env.REACT_APP_ROLE_ADMIN ? (
              <div className="col-md-3 col-lg">
                <div className="border rounded p-2 text-center bg-light">
                  <small>This Week Revenue</small>
                  <div className="fw-bold">{revenueData?.totalRevenue ? revenueData?.totalRevenue : revenue}</div>
                </div>
              </div>
            ) : (
              <div className="col-md-3 col-lg">
                <div className="border rounded p-2 text-center bg-light">
                  <small>This Week Revenue</small>
                  <div className="fw-bold">{revenue}</div>
                </div>
              </div>
            )} */}
            <div className="col-md-3 col-lg">
              <div className="border rounded p-2 text-center bg-light">
                <small>Total Calls</small>
                <div className="fw-bold">
                  {callTrackingToday?.CallRecordCount}
                </div>
              </div>
            </div>

            <div className="col-md-3 col-lg">
              <div className="border rounded p-2 text-center bg-light">
                <small>Attempted</small>
                <div className="fw-bold">
                  {callTrackingToday?.attemptedCount}
                </div>
              </div>
            </div>

            <div className="col-md-3 col-lg">
              <div className="border rounded p-2 text-center bg-light">
                <small>Incoming</small>
                <div className="fw-bold">{callTrackingToday?.inboundCount}</div>
              </div>
            </div>

            <div className="col-md-3 col-lg">
              <div className="border rounded p-2 text-center bg-light">
                <small>Outgoing</small>
                <div className="fw-bold">
                  {callTrackingToday?.outboundCount}
                </div>
              </div>
            </div>

            <div className="col-md-3 col-lg">
              <div className="border rounded p-2 text-center bg-light">
                <small>Answered</small>
                <div className="fw-bold">
                  {callTrackingToday?.answeredCount}
                </div>
              </div>
            </div>

            <div className="col-md-3 col-lg">
              <div className="border rounded p-2 text-center bg-light">
                <small>Unanswered</small>
                <div className="fw-bold">
                  {callTrackingToday?.unAnsweredCount}
                </div>
              </div>
            </div>

            <div className="col-md-3 col-lg">
              <div className="border rounded p-2 text-center bg-light">
                <small>Duration</small>
                <div className="fw-bold">
                  {formatSecondsToHMS(callTrackingToday?.totalDuration)}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-body mt-1" style={{ minHeight: "90vh" }}>
          <div className="card">
            <div
              className="card-body"
              style={{ display: "flex", overflowX: "auto", gap: "1rem" }}
            >
              {statuses?.map((status, index) => {
                const leadsByStatus = getLeadsByStatus(status);
                const getCountByStatus = () => {
                  if (status === "Todays Leads") {
                    let dt = data?.filter(
                      (lead) => !lead.lead_status || lead.lead_status === ""
                    );
                    return dt?.length || 0;
                  } // ✅ PAGINATED DATA (use .data)
                  else if (status === "Today's Foll. Last") {
                    return allLeadsData?.todaysFlwCount;
                  } else if (status === "Today's Foll. Inside") {
                    return allLeadsData?.todaysFlwAllCount;
                  } else if (status === "followup in one day") {
                    return allLeadsData?.followUp1Count;
                  } else if (status === "followup in two day") {
                    return allLeadsData?.followUp2Count;
                  } else if (status === "followup in four day") {
                    return allLeadsData?.followUp4Count;
                  } else if (status === "followup in one week") {
                    return allLeadsData?.followUp1WCount || 0;
                  } else if (status === "followup in two week") {
                    return allLeadsData?.followUp2WCount;
                  } else if (status === "followup in one month") {
                    return allLeadsData?.followUp1MCount || 0;
                  } else if (status === "Pending Followup") {
                    return allLeadsData?.pendingFlwCount || 0;
                  } else if (status === "cold lead") {
                    return allLeadsData?.coldLeadsCount || 0;
                  }

                  return 0;
                };

                const currentKey = statusKeyMap[status];
                const currentData = allLeadsData?.[currentKey];
                return (
                  <div
                    key={index}
                    className="listName flex-column"
                    style={{
                      padding: "0.5rem",
                      border: "1px solid #c4c4c4",
                      borderRadius: "0.5em",
                      minWidth: "20em",
                      maxHeight: "80vh",
                      overflowY: "auto",
                      background: "#fff",
                    }}
                  >
                    <h3
                      style={{
                        margin: 0,
                        padding: "0.6em",
                        background: "#000",
                        color: "#fff",
                        textAlign: "center",
                        position: "sticky",
                        top: 0, // ✅ IMPORTANT
                        zIndex: 10, // ✅ keeps it above content
                        borderRadius: "0.3em",
                      }}
                    >
                      {status.toUpperCase()} ({getCountByStatus()})
                    </h3>

                    {/* Todays Leads */}

                    {status === "Todays Leads" && (
                      <div style={{ marginTop: "0.5rem" }}>
                        <div className="fs-6 fw-bold  mb-2 text-uppercase bg-primary-lt p-2">
                          Handle potential leads with urgency, Remember delay
                          kills interest.
                          <hr className="m-1 p-0"></hr>
                          If pending followups are more than hundread new leads
                          will not be assigned.
                        </div>

                        {leadsByStatus?.map((lead) => (
                          <div
                            key={lead.id}
                            // className={`card p-2 mb-2 ${
                            //   lead?.not_received ? "bg-red-lt" : "bg-yellow-lt"
                            // }`}
                            className={`card p-2 mb-2 ${
                              lead?.origin === "hydroponics_kryzen_com"
                                ? "bg-green-lt"
                                : lead?.not_received
                                ? "bg-red-lt"
                                : "bg-yellow-lt"
                            }`}
                          >
                            <div
                              style={{ fontWeight: "bold", fontSize: "14px" }}
                            >
                              <strong>Full Name:</strong>{" "}
                              {lead.fullName?.toUpperCase() || "N/A"}
                            </div>
                            <div>
                              <strong>Contact:</strong>{" "}
                              {lead.mobileNumber || "N/A"}
                            </div>
                            <div>
                              <strong>Email:</strong> {lead.email || "N/A"}
                            </div>
                            <div>
                              <strong>City:</strong> {lead.city || "N/A"}
                            </div>
                            <div>
                              <strong>State:</strong> {lead.state || "N/A"}
                            </div>
                            <div>
                              <strong>Source:</strong> {lead.origin || "N/A"}
                            </div>
                            {lead?.consultationDate && (
                              <div>
                                <strong>Consultation Date:</strong>{" "}
                                {lead?.consultationDate || "N/A"}
                              </div>
                            )}
                             {lead?.consultationTime && (
                              <div>
                                <strong>Consultation Time:</strong>{" "}
                                {lead?.consultationTime || "N/A"}
                              </div>
                            )}
                            {lead?.lead_quality && (
                              <div>
                                <strong>Enquiry Quality:</strong>{" "}
                                {lead?.lead_quality || "N/A"}
                              </div>
                            )}

                            {lead?.customer_stage && (
                              <div>
                                <strong>Customer Stage:</strong>{" "}
                                {lead?.customer_stage || "N/A"}
                              </div>
                            )}

                            {lead?.interestLevel && (
                              <div>
                                <strong>Interest Level:</strong>{" "}
                                {lead?.interestLevel || "N/A"}
                              </div>
                            )}

                            <div>
                              <hr className="p-0 m-1"></hr>
                              <td colSpan="2">
                                <button
                                  className="btn btn-sm px-3 btn-primary"
                                  data-bs-toggle="modal"
                                  disabled={!lead?.mobileNumber}
                                  data-bs-target="#enquiry-report"
                                  onClick={() => setModalData(lead)}
                                >
                                  Assign To Me
                                </button>
                                <button
                                  className="btn btn-sm px-2 btn-danger ms-2"
                                  // data-bs-toggle="modal"
                                  disabled={
                                    !lead?.mobileNumber || lead?.not_received
                                  }
                                  // data-bs-target="#enquiry-report"
                                  onClick={() => handleNotReceived(lead)}
                                >
                                  Not Attended
                                </button>
                              </td>
                            </div>
                          </div>
                        ))}
                        <div className="card-header d-flex justify-content-center">
                          {/* <h3 className="card-title">New enquiries</h3> */}
                          <button
                            disabled={
                              data?.length >= 80 ||
                              allLeadsData?.todaysFlw?.length +
                                allLeadsData?.pendingFlw?.length >
                                99
                            }
                            onClick={assignNewEnquires}
                            className="btn btn-primary mx-1"
                          >
                            Get new enquiries
                          </button>
                        </div>
                      </div>
                    )}

                    {/* Todays Leads */}
                    {status !== "Todays Leads" && (
                      <>
                        <div style={{ marginTop: "0.5rem" }}>
                          {status === "Pending Followup" && (
                            <div className="mb-2 fs-6 fw-bold text-uppercase bg-primary-lt p-2">
                              The difference between average salespeople and top
                              closers is simple: top closers never leave
                              follow-ups pending.
                            </div>
                          )}
                          {status === "Today's Foll. Last" && (
                            <div className="mb-2 fs-6 fw-bold text-uppercase bg-primary-lt p-2">
                              Today’s follow-ups are today’s Incentive. Don't
                              carry them tomorrow.
                            </div>
                          )}

                          {leadsByStatus?.map((lead) => (
                            <div
                              key={lead.id}
                              className={`card p-2 mb-2 ${
                                status === "Pending Followup"
                                  ? "bg-red-lt z-0"
                                  : status === "cold lead"
                                  ? "bg-orange-lt"
                                  : "bg-lime-lt"
                              }`}
                            >
                              {/* <div
                                style={{ fontWeight: "bold", fontSize: "14px" }}
                              >
                                <strong>Score :</strong>{" "}
                                {lead?.leadScore || "N/A"}
                              </div> */}
                              <div
                                style={{ fontWeight: "bold", fontSize: "14px" }}
                              >
                                <strong>Full Name:</strong>{" "}
                                {lead?.full_name?.toUpperCase() || "N/A"}
                              </div>
                              <div>
                                <strong>Contact Num:</strong>{" "}
                                {lead?.contact_number || "N/A"}
                              </div>
                              <div>
                                <strong>Learning:</strong>{" "}
                                {lead?.interested_in?.join(", ") || "N/A"}
                              </div>

                              {/* <div>
                              <strong>Email:</strong> {lead?.email || "N/A"}
                            </div>
                            <div>
                              <strong>Enquiry related to:</strong>{" "}
                              {lead?.enquiry_related_to || "N/A"} 
                            </div> */}
                              {/* <div>
                                <strong>Lead closer:</strong>{" "}
                                {lead?.closerDetails?.userName ||
                                  "Not assigned"}
                              </div> */}
                              <div>
                                <strong>Lead custodian:</strong>{" "}
                                {lead?.assignedTo?.userName || "N/A"}
                              </div>

                              {/* FOLLOWUP BUTTON */}
                              <div
                                style={{
                                  marginTop: "2px",
                                  cursor: "pointer",
                                  fontWeight: "600",
                                  color: "#2c6e49",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                                onClick={() => toggleFollowup(lead.id)}
                              >
                                <div>Follow Up</div>
                                <div>
                                  {openFollowup === lead.id ? "▲" : "▼"}
                                </div>
                              </div>
                              {/* FOLLOWUP DETAILS */}
                              {openFollowup === lead.id && (
                                <div
                                  style={{
                                    marginTop: "8px",
                                    background: "#ffffff",
                                    padding: "8px",
                                    borderRadius: "4px",
                                    fontSize: "13px",
                                  }}
                                >
                                  {lead?.followUp?.map((item, index) => (
                                    <div
                                      key={item?.id || index}
                                      style={{ marginBottom: "6px" }}
                                    >
                                      <div>
                                        <strong>Followup Date:</strong>{" "}
                                        {item?.followUpDate || "N/A"}
                                      </div>

                                      <div>
                                        <strong>Followup Message:</strong>{" "}
                                        {item?.followUp || "No Message"}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}

                              <button
                                className="btn btn-sm px-3 btn-primary mt-2"
                                onClick={() => {
                                  navigate(`/leads/edit-new-lead/${lead?.id}`);
                                }}
                              >
                                Edit
                              </button>
                            </div>
                          ))}
                        </div>
                        {currentData?.data?.length > 0 && (
                          <hr className="m-0 p-0"></hr>
                        )}
                        {status !== "Todays Leads" &&
                          currentData &&
                          currentData?.data?.length > 0 && (
                            <div className="d-flex justify-content-between align-items-center mt-2">
                              {/* 🔙 PREV BUTTON */}
                              {currentData.page > 1 ? (
                                <button
                                  className="btn btn-sm btn-outline-secondary"
                                  onClick={() => handlePrev(currentKey)}
                                >
                                  Prev
                                </button>
                              ) : (
                                <div>
                                  <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() => handlePrev(currentKey)}
                                    disabled
                                  >
                                    Prev
                                  </button>
                                </div>
                              )}

                              {/* PAGE INFO */}
                              {
                                <small>
                                  Page {currentData.page} /{" "}
                                  {currentData.totalPages}
                                </small>
                              }

                              {/* 🔜 NEXT BUTTON */}
                              {currentData.page < currentData.totalPages ? (
                                <button
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() => handleLoadMore(currentKey)}
                                >
                                  Next
                                </button>
                              ) : (
                                <div>
                                  <button
                                    className="btn btn-sm btn-outline-primary"
                                    disabled
                                    onClick={() => handleLoadMore(currentKey)}
                                  >
                                    Next
                                  </button>
                                </div>
                              )}
                            </div>
                          )}
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          <div
            class="modal modal-blur fade"
            id="enquiry-report"
            tabIndex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div
              class="modal-dialog modal-lg modal-dialog-centered"
              role="document"
            >
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Filter lead</h5>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body">
                  {modalData && (
                    <>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Full name
                        </label>
                        <div className="w-100 col">
                          {(
                            modalData?.fullName ||
                            modalData?.firstName ||
                            "N/A"
                          ).toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">Address</label>
                        <div className="w-100 col">
                          {(
                            modalData.address1 ||
                            modalData.address2 ||
                            "N/A"
                          ).toUpperCase()}
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Email Address
                        </label>
                        <div className="w-100 col">
                          {modalData?.email || "N/A"}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Phone Number
                        </label>
                        <div className="w-100 col">
                          {modalData?.mobileNumber ||
                          modalData?.whatsappNumber ? (
                            <span
                              onClick={() =>
                                handleCall(
                                  modalData?.mobileNumber ||
                                    modalData?.whatsappNumber
                                )
                              }
                              className="cursor-pointer text-blue text-decoration-underline"
                            >
                              <svg
                                color="green"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                class="icon icon-tabler icons-tabler-outline icon-tabler-phone-outgoing"
                              >
                                <path
                                  stroke="none"
                                  d="M0 0h24v24H0z"
                                  fill="none"
                                />
                                <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" />
                                <path d="M15 9l5 -5" />
                                <path d="M16 4l4 0l0 4" />
                              </svg>

                              {modalData?.mobileNumber ||
                                modalData?.whatsappNumber}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      {/* <div className="mb-3 row d-lg-none d-md-none">
                              <label className="w-25 form-label col-3">Call Now</label>
                              <div className="w-100 col">
                                <SimpleButton buttonText="Call Now" />
                              </div>
                            </div> */}
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Lead Generated From
                        </label>
                        <div className="w-100 col">
                          {(modalData?.origin || "N/A").toUpperCase()}
                        </div>
                      </div>
                      {modalData?.summary && (
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Lead Summary / Intrested In
                          </label>
                          <div className="w-100 col">
                            {(modalData?.summary || "N/A").toUpperCase()}
                          </div>
                        </div>
                      )}
                      {/* CHAT SECTION */}
                      {modalData?.aiScript?.length > 0 && (
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">Chat</label>

                          <div className="w-100 col">
                            <div
                              style={{
                                height: "400px",
                                overflowY: "auto",
                                border: "1px solid #ddd",
                                borderRadius: "10px",
                                padding: "10px",
                                background: "#f8f9fa",
                              }}
                            >
                              {modalData?.aiScript?.length > 0 ? (
                                modalData.aiScript.map((item, index) => (
                                  <div key={index} className="mb-3">
                                    <div
                                      style={{
                                        background: "#e9f5ff",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        marginBottom: "5px",
                                      }}
                                    >
                                      <strong>Aarya:</strong>{" "}
                                      {item?.arya || item?.assistant}
                                    </div>

                                    <div
                                      style={{
                                        background: "#fff",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #eee",
                                      }}
                                    >
                                      <strong>Customer:</strong>{" "}
                                      {item?.customer}
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div>No Chat Available</div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="mb-3 row">
                        <span className="text-red">
                          Marking a call as “Connected” when it is not actually
                          connected will result in a negative EEP Score, and all
                          entries will be verified through the Call Tracker
                          system. Any employee found hoarding leads or
                          manipulating lead status will have their entire
                          month’s incentive cancelled.
                        </span>
                      </div>
                    </>
                  )}
                </div>

                <div class="modal-footer">
                  <div>
                    <SimpleButton
                      buttonText="Not Connected"
                      type="secondary"
                      data-bs-dismiss="modal"
                    />
                  </div>

                  <div class="ms-auto">
                    <SimpleButton
                      onClick={() => AddAndAssignLead(modalData)}
                      buttonText="Call Connected"
                      data-bs-dismiss="modal"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default LeadsTrackingSystem;
